var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"c-group-item"},[_c('Avatar',{attrs:{"user":_vm.user,"readonly":true}}),_c('h2',{staticClass:"m-text-cut"},[_vm._v(" "+_vm._s(_vm.userName)+" "),_c('UserTitle',{attrs:{"user":_vm.user}})],1),(_vm.choose)?_c('svg',{staticClass:"m-style-svg m-svg-def"},[_c('use',{attrs:{"xlink:href":"#icon-qs_focused"}})]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }